import apiClient from './api';

export interface TranslationResult {
  translatedText: string;
  detectedSourceLanguage?: string;
}

export interface TranslateRequest {
  text: string;
  sourceLanguage: string;
  targetLanguage: string;
}

export const translationService = {
  /**
   * Translates text using Google Translate API via backend proxy
   */
  async translateText(request: TranslateRequest): Promise<TranslationResult> {
    const response = await apiClient.post<TranslationResult>(
      '/translate',
      {
        text: request.text,
        sourceLanguage: request.sourceLanguage,
        targetLanguage: request.targetLanguage,
      }
    );
    return response.data;
  },
};
